<div class="personal-container" data-testid="personal-container">
  <main class="personal-main" data-testid="personal-main">
    <!-- Loading State -->
    <!--    <div class="loading-state" data-testid="personal-loading-state" *ngIf="isLoading$ | async">-->
    <!--      <p>{{ "loading" | translate }}</p>-->
  <!--    </div>-->

  <!-- Wheel: Empty state-->
  @if (shouldShowEmptyState$ | async) {
    <div class="empty-state" data-testid="personal-empty-state">
      @if (isAuthenticatedAndVerified$ | async) {
        <wil-empty-state></wil-empty-state>
      } @else {
        <wil-verify-email-page></wil-verify-email-page>
      }
    </div>
  } @else {
    @if (activeWheelId$ | async; as activeWheelId) {
      <wil-wheel [type]="(plan$ | async) || 'free'" [wheelId]="activeWheelId" [clientId]="userId$ | async"></wil-wheel>
    }
  }

  <!-- Wheel-->
</main>
</div>
